import React from 'react';
import {Row, Col, Modal, ModalHeader, Spinner} from "reactstrap";
import Lottie from 'react-lottie-player';
import './loader.scss'; // Add your loader styles here
//import lottieJson from '../../assets/images/animation_llig5kb8.json';

const Loader = ({ isOpen, lottieJson, messageHeader, message }) => {
  return (
    <Modal
        isOpen={isOpen}
        className="loader-modal"
        //role="dialog"
        autoFocus={true}
        keyboard={false}
        centered
        backdrop="static"
        size='lg'
    >
        <div className="modal-body">
          <Row className="full-width">
            <Col lg="6" className="mx-auto">
                <Lottie
                    loop
                    animationData={lottieJson}
                    play
                    //style={{ width: 250, height: 250 }}
                />
            </Col>
            <Col lg="6" className='my-auto'>
                <h1>{messageHeader}</h1>
                <p className='align-middle'>{message}</p>
            </Col>
          </Row>
        </div>
    </Modal>
  );
};

export default Loader;
